module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("For my good and beautiful community:")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("Meghan Smith, Matt Johnson, Catherine Johnson, Janeen Sehl, Patrick Sehl, Laura Fox, C. J. Fox, Jimm Taylor and Andrew Tash")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('em', [_vm._v("For standing with me,")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('em', [_vm._v("heart and soul")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("1 Samuel 14:7 niv")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4798650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dedication.vue
// module id = 66
// module chunks = 0